import { categoryDetailSubCategoriesStyles } from "@insite/content-library/Widgets/Category/CategoryDetailSubCategories";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(categoryDetailSubCategoriesStyles, {
    container: {
        gap: 20,
        css: css`
            padding-left: 25px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding-left: 0;
                        margin-top: 25px;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    subCategoryItem: {
        width: [12, 4, 3, 3, 2],
        css: css`
            margin-bottom: 5px !important;
            display: flex;
            flex-direction: column;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 15px !important;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    innerContainer: {
        gap: 20,
        css: css`
            // background: #fff;
            box-shadow: 0 0 4px 0 rgb(0 0 0 / 50%);
            padding: 0.5375em;
        `,
    },
    subCategoryImageItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            width: 100%;
            padding-bottom: 8px;
        `,
    },
    subCategoryImageClickable: {
        css: css`
            width: 100%;
        `,
    },
    subCategoryImage: {
        css: css`
            img {
                height: 100%;
            }
            width: 100%;
        `,
    },
    subCategoryNameLinkItem: {
        width: [12, 12, 12, 12, 12],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                    css`
                        justify-content: center;
                    `,
                ])}
        `,
    },
    subCategoryNameLink: {
        css: css`
            width: 100%;
        `,
        color: "text.main",
        typographyProps: {
            weight: "bold",
            css: css`
                width: 100%;
                text-align: center;
                word-wrap: break-word;
            `,
        },
    },
});
